<template>
  <div class="contais">
    <!-- 面包屑导航栏 -->
    <div class="con_heads">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>汽车典当业务</el-breadcrumb-item>
        <el-breadcrumb-item>汽车复核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 内容部分 -->

    <div class="contens">
      <el-table :data="items" border style="width: 100%">
        <el-table-column prop="dates" label="填表日期" width="180"> </el-table-column>
        <el-table-column prop="piaonum" label="票号" width="130"> </el-table-column>
        <el-table-column prop="name" label="当户姓名" width="120"> </el-table-column>
        <el-table-column prop="tel" label="联系电话" width="120"> </el-table-column>
        <el-table-column prop="plateNumber" label="车牌号" width="120"> </el-table-column>
        <el-table-column prop="brand" label="汽车品牌" width="120"> </el-table-column>
        <el-table-column prop="radio" label="车辆状态" width="120"> </el-table-column>
        <el-table-column prop="mileage" label="公里数/KM" width="120"> </el-table-column>
        <el-table-column prop="IllegalProcessing" label="违章情况" width="120"> </el-table-column>
        <el-table-column prop="overallValuation" label="车辆估值" width="120"> </el-table-column>
        <el-table-column prop="sum" label="典当金额" width="100"> </el-table-column>
        <el-table-column prop="comprehensive" label="典当综合费" width="120"> </el-table-column>
        <el-table-column prop="lx" label="典当利息" width="120"> </el-table-column>
        <el-table-column prop="startDate" label="开始日期" width="120"> </el-table-column>
        <el-table-column prop="DateClosed" label="到期日期" width="120"> </el-table-column>
        <el-table-column prop="det" label="典当天数" width="100"> </el-table-column>
        <el-table-column prop="parkingFee" label="停车费" width="100"> </el-table-column>
         <el-table-column prop="command" label="分期/期" width="100"> </el-table-column>
        <el-table-column prop="agent" label="经办人" width="120"> </el-table-column>
        <el-table-column fixed="left" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row._id)" type="text" size="small"
              >查看详情</el-button
            >
            <el-button type="text" size="small" @click="freView(scope.row._id)"
              >复核</el-button
            >
            <el-button type="text" size="small" @click="deTeLes(scope.row._id)">删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 弹窗    -->
      <!-- <el-dialog title="查看详情" :visible.sync="dialogTableVisible">
        <CarDetail :item="item"></CarDetail>
      </el-dialog> -->
    </div>
  </div>
</template>
<script>
// import CarDetail from '@/components/cars/CarDetail'
// import CarDetail from '../components/cars/CarDetail.vue';
export default {
  name: "Reviews",
  data() {
    return {
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      items: [], //请求回来的待复核的数据
      item:"",   //请求的数据
      // dialogTableVisible: false, //弹窗默认关闭
      detais: [], //点击查看详情的数据
    };
  },

  components:{
    // CarDetail
  },

  methods: {
    //获取到待复核的数据 最大请求1000条数据
    getdatas() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("car_data").where({reviewer:_.eq("")}).limit(1000).get()',
        })
        .then((res) => {
          if(res.data.errcode !== 0){
            return this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
          }
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = res.data.data;
        });
    },

    //点击查看
    handleClick(events) {
      this.$router.push({ path: "/Car/CarDetail", query: { id: events } });
    },
    //点击复核
    freView(e) {
      let fid = e;
      this.$router.push({ path: "/Car/car_details", query: { id: fid } });
    },

    //删除
    deTeLes(e){
       this.$confirm('确定要删除该业务吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        this.axios
        .post("/api/tcb/databasedelete?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("car_data").doc("${e}").remove()`,
        })

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    
    },
  },

  //组件创建时
  created() {
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //ACCESS_TOKEN
       //获取到this.ACCESS_TOKEN
     this.getTokens()

     //获取当前登录的用户数据
    this.getUserToken()
  },

  //组件挂载时
  mounted() {
    setTimeout(()=>{
      this.getdatas();
    },800)
    
  },
};
</script>
<style scoped>
.contens {
  margin: 20px auto;
}
.con_heads {
  background-color: #ffffff;
  padding: 15px;
}


</style>
